import { del, get, post, put } from '../utility/http';

// GET switch drone/sensor in assets page
export async function fetchUserAsset(type: string) {
  try {
    const response = await get(
      `/asset-management/userhasasset/myassets/${type}`,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchAsset() {
  try {
    const response = await get('/asset-management/assets', true);
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function addAssetToUser(body: any) {
  try {
    const response = await post(
      '/asset-management/userhasasset',
      true,
      {},
      body
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function suspendAssetToUser(body: any, idUserAsset: number) {
  try {
    const response = await put(
      `/asset-management/userhasasset/${idUserAsset}`,
      true,
      {},
      body
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function removeAssetToUser(idUserAsset: number) {
  try {
    const response = await del(
      `/asset-management/userhasasset/${idUserAsset}`,
      true,
      {}
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

// GET when click on red/green availability circle 
export async function getDroneDetailToView(id: number){
  try {
    const response = await get(
      `/asset-management/userhasasset/myasset/${id}`,
      true,
      {}
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function getSensorDetailToView(id: number){
  try {
    const response = await get(
      `/asset-management/userhasasset/myasset/${id}`,
      true,
      {}
    );
    return response;
  } catch (e:any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function getDroneAvailability({startDate, endDate, role, jobId}:any){
  try {
    let response = null;
    if(jobId)
    {
      response = await post(
        encodeURI(
          `/data/availableassets?startDatetime=${startDate}&endDatetime=${endDate}&jobId=${jobId}`),
        true,
        {},
        role
      );
    }
    else
    {
      response = await post(
        encodeURI(`/data/availableassets?startDatetime=${startDate}&endDatetime=${endDate}`),
        true,
        {},
        role
      );
    }
    return response;
  } catch (e:any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function getFederatedTo(role:string){
  try {
    const response = await get(
      `/federation/users/${role}/federatedto/`,
      true,
      {}
    );
    return response;
  } catch (e:any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

// GET when click on red/green availability circle (other)
export async function getAssetJobs(id:any){
  try {
    const response = await get(
      `/data/jobs/userhasassets/${id}`,
      true,
      {}
    );
    return response;
  } catch (e:any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function getAssetSensorJobs(id:any){
  try {
    // const response = await get(
    //   `http://localhost:8080/data/jobs/userhasassets/sensor/${id}`,
    //   false,
    //   {},
    //   true,
    // );
    const response = await get(
      `/data/jobs/userhasassets/sensor/${id}`,
      true,
      {}
    );
    return response;
  } catch (e:any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

// GET for first asset page
export async function getAllAssetBusy({startDate, endDate, role}:any){
  try {
    // const response = await get(
    //   `http://localhost:8080/data/availableassets/users/${role}` +
    //   `?startDatetime=${startDate}&endDatetime=${endDate}`,
    //   false,
    //   {},
    //   true
    // );
    const response = await get(
      `/data/availableassets/users/${role}?startDatetime=${startDate}&endDatetime=${endDate}`,
      true,
      {}
    );
    return response;
  } catch (e:any) {
    return Promise.reject(e.response ? e.response : e);
  }
}
